module.exports = __webpack_public_path__ + "img/OBCINA AJDOVSCINA.9a513241.png";